/** @format */
import { Pipe, PipeTransform } from '@angular/core';
import { dateUtils } from 'common-typescript/constants';
import { LocalDateRange, LocalDateTimeRange } from 'common-typescript/types';
import moment from 'moment';

/**
 * Is LocalDateRange / LocalDateTimeRange in the past (compared to targetDate). Note that null/undefined range will always result in false.
 */
@Pipe({
    name: 'dateRangePast',
    standalone: false,
})
export class DateRangePastPipe implements PipeTransform {
    transform(value: LocalDateRange | LocalDateTimeRange, targetDate?: string): boolean {
        return !!value && dateUtils.isRangeBefore(moment(targetDate), value);
    }
}
